import * as React from 'react';
import { ProgressCircle } from '@mitchell/react.component.ux';
import { StyledOverlayDiv, StyledSpinnerDiv } from './IntelligentPhotoCaptureEstimatorLoaderComponent.style';
export const IntelligentPhotoCaptureEstimatorLoaderComponent = ({ shouldShowLoader }) => {
    return shouldShowLoader ? (React.createElement(StyledOverlayDiv, null,
        React.createElement(StyledSpinnerDiv, null,
            React.createElement(ProgressCircle, null)))) : null;
};
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorLoaderComponent.js.map